import { FC } from 'react';
import { Button, Spinner } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  isLoading?: boolean;
  disabled?: boolean;
  onClick: (event: any) => Promise<void>;
}

const ButtonSearch: FC<IProps> = ({
  isLoading,
  disabled,
  onClick
}) => {
  return (
    <Button
      disabled={disabled || isLoading || false}
      type="button"
      onClick={(e) => onClick(e)}
    >
      {isLoading &&
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      }
      <FontAwesomeIcon icon={faMagnifyingGlass} className='me-2' />
      <span>{t("SEARCH")}</span>
    </Button>
  );
}

export default ButtonSearch;